import React from "react";
import image1 from "../img/Conditions to bloom in winter part 111&&to wait and to despair---Adobe Photoshop interweaving of textured layers over AI-generated and curated images___2025-05[[4]].jpg"
export default function Machine_1() {
  return (
    <div className="panel-block">
      

      <div className="panel-container-left">
        <img
          loading="lazy"
          src={image1}
          alt="1 · THE MACHINE"
        />
      </div>

      <div className="panel-container-right">
        <h2>1 · THE Vakzthari MACHINE</h2>
        <p>You have tried.</p>
    <p>You have been there.</p>
    <p>The Machine was there.</p>
    <p>The Machine is and will be there.</p>
    <p>Somewhere. Nowhere. Everywhere.</p>
    <p>For you, it is the border between sanity and madness.</p>
    <p>At the dawn of old times. Forever.</p>
    <p>At the dusk of the new fog.</p>
    <p>In the mist of everything that is casually on purpose.</p>
      </div>
    </div>
  );
}
